// extracted by mini-css-extract-plugin
export default {"innerWrapper":"nt-z","tooltipWrapper":"ot-z","icon":"pt-z","tooltip":"qt-z","content":"rt-z"};